export default __webpack_public_path__ + "static/media/community-home-page.ff621e74.png";